import * as Adaptive from 'adaptivecards';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isFeatureEnabled } from 'owa-feature-flags';

interface Person {
    name: string;
    smtp: string;
}

export default class CustomTextBlock extends Adaptive.TextBlock {
    private mentions: Person[];
    private lpcElement: HTMLDivElement;

    protected internalRender(): HTMLElement {
        if (
            !isFeatureEnabled('rp-actionableMessages-lpc') ||
            !this.mentions ||
            this.mentions.length == 0
        ) {
            return super.internalRender();
        }

        this.lpcElement = super.internalRender() as HTMLDivElement;

        this.mentions.forEach(mention => {
            // This is safe from an xss perspective since what we're doing is taking the already present (and already sanitized) content
            // of the lpcElement and wrapping it in a span.  mention.name is already present in the in the element and this code is
            // taking that exact content and setting it as the data-mention-name prop of a span
            // tslint:disable-next-line:no-inner-html
            this.lpcElement.innerHTML = this.lpcElement.innerHTML.replace(
                new RegExp(mention.name, 'i'),
                `<span data-mention-name="${mention.name}"></span>`
            );
        });
        this.mentions.forEach(mention => this.renderLPC(mention));

        return this.lpcElement;
    }

    public parse(json: any) {
        super.parse(json);
        this.mentions = json.mentions;
    }

    private renderLPC = (mention: Person) => {
        /* tslint:disable:no-string-literal */
        const LivePersonaCardHoverTargetV2 = window['LivePersonaCardHoverTargetV2'];
        /* tslint:enable:no-string-literal */

        const lpcCard = (
            <LivePersonaCardHoverTargetV2
                cardParameters={{
                    personaInfo: {
                        identifiers: {
                            Smtp: mention.smtp,
                            PersonaType: 'User',
                        },
                    },
                    behavior: {
                        locationToOpen: 'Card',
                    },
                }}>
                <span data-debug={mention.name} style={{ display: 'inline-block' }}>
                    {mention.name}
                </span>
            </LivePersonaCardHoverTargetV2>
        );
        const element = this.lpcElement.querySelector(`[data-mention-name='${mention.name}']`);

        ReactDOM.render(lpcCard, element);
    };
}

// initilizationlivePersonaCardAsync
